import LocalStorageService from "../../../core/services/local-storage.service";
import { getSanctionsUrl } from "../../../utils/sanctionsUrl";
import { getHSCodeClassificationUrl } from "../../../utils/hsCodeClassificationUrl";
import { getUmsDashboardUrl } from "../../../utils/umsDashboardUrl";
import { getProductMasterURL } from "../../../utils/getProductMatserUrl";
import { getIntelUrl } from "../../../utils/intelUrl";
import { getSourceAtlasUrl } from "../../../utils/sourceAtlasUrl";
import { ComplianceApiUrl } from "../../../utils/getComplianceApiUrl";
import { getTradeMapUrl } from "../../../utils/getTradeMapUrl";
import { getFinScreenerUrl } from "../../../utils/getFinScreenerUrl";

const localStorageService = LocalStorageService.getService();

export const productDropdownConfig = () => {
  let token = localStorageService.getAccessToken();
  let session = localStorageService.getSessionID();
  let expiry = localStorageService.getExpiryDate() || localStorageService.getSessionExpiryDate();

  return token && session && expiry
    ? {
        intel: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658586/trade%20compliance/trademo_intel_xokun3.svg",
          name: "Intel",
          redirectionKey: "intel",
          // Intel's landing route needs `P` present but never reads its value.
          redirectionUrl: getIntelUrl() + "intel?T=" + token + "&I=" + session + "&D=" + expiry + "&Type=D&P=intel-us",
          mainKey: "intel",
          subHeading: "Supply chain intelligence for sales, procurement & research",
        },
        source_atlas: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1787037875/intel/misc/Source_Atlas_All_apps_dahh5x.svg",
          name: "Source Atlas",
          redirectionKey: "source_atlas",
          redirectionUrl: getSourceAtlasUrl() + "intel?T=" + token + "&I=" + session + "&D=" + expiry + "&Type=D&P=source_atlas",
          mainKey: "source_atlas",
          subHeading: "Supply chain intelligence for sales, procurement & research",
        },
        sanctions: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658583/trade%20compliance/sanctions_screener_pesy2b.svg",
          name: "Sanctions Screener",
          redirectionKey: "sanctions_screener",
          redirectionUrl: getSanctionsUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=sanctions",
          mainKey: "sanctions",
          subHeading: "Screen stakeholders against restricted party lists",
        },

        trade_reference: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658585/trade%20compliance/trade_ref_cdotlp.svg",
          name: "Global Trade Content",
          redirectionKey: "trade_reference",
          redirectionUrl: ComplianceApiUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=trade-compliance&Tab=classify",
          mainKey: "trade_reference",
          subHeading: "Real-time trade compliance data on tariffs, duties and rulings",
        },
        hs_classifier: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658574/trade%20compliance/hs_classifier_tseyjp.svg",
          name: "HS Classifier",
          redirectionKey: "hs_classifier",
          redirectionUrl: getHSCodeClassificationUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=hs-code-classification&F=gtm",
          mainKey: "hs_classifier",
          subHeading: "Use AI powered classifier to assign products with accurate HS Codes",
        },
        hs_classifier_ai: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658574/trade%20compliance/hs_classifier_tseyjp.svg",
          name: "AI Chatbot HS Classifier",
          redirectionKey: "hs_classifier",
          redirectionUrl: getHSCodeClassificationUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=hs-code-classification&F=gtm&tab=chatbot",
          mainKey: "hs_classifier",
          subHeading: "Use AI powered chatbot to assign products with accurate HS Codes",
        },
        landed_cost: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658581/trade%20compliance/landed_cost_calculator_gci8pf.svg",
          name: "Landed Cost Calculator",
          redirectionKey: "landed_cost_calculator",
          redirectionUrl: ComplianceApiUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=trade-compliance&Tab=landedcostcalculator",
          mainKey: "landed_cost",
          subHeading: "Calculate the true landed cost of your imports & exports shipments",
        },
        product_master: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1712658582/trade%20compliance/product_master_f1bugz.svg",
          name: "Product Master",
          redirectionKey: "product_master",
          redirectionUrl: getProductMasterURL() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=product-master&N=",
          mainKey: "product_master",
          subHeading: "Streamline trade compliance data management",
        },
        trademap: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1715335533/intel/icons/trademo_map_ltxuo7.svg",
          name: "Map",
          redirectionKey: "trademap",
          redirectionUrl: getTradeMapUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=trademap",
          mainKey: "trademap",
          subHeading: "Multi-tier supply chain mapping and compliance",
        },
        tradescreen: {
          imageUrl: "https://res.cloudinary.com/drzta9shk/image/upload/v1726134122/intel/icons/fin_screen_zqywy1.svg",
          name: "FinScreen",
          redirectionKey: "fin_screener",
          mainKey: "fin_screener",
          subHeading: "Screen trade invoices to detect financial crime",
          redirectionUrl: getFinScreenerUrl() + "?T=" + token + "&I=" + session + "&D=" + expiry + "&P=fin_screener&N=",
        },
      }
    : null;
};
export const umsRedirection = () => {
  let token = localStorageService.getAccessToken();
  let session = localStorageService.getSessionID();
  let expiry = localStorageService.getExpiryDate() || localStorageService.getSessionExpiryDate();
  const userData = JSON.parse(localStorage.getItem("UserInfo"));

  return token && session && expiry
    ? {
        title: "User Management System",
        mainKey: "userManagement",
        subProductList: [],
        redirectionKey: "user_management_system",
        redirectionUrl:
          getUmsDashboardUrl() +
          "?T=" +
          token +
          "&I=" +
          session +
          "&D=" +
          expiry +
          "&userId=" +
          (userData.userId || "") +
          "&OrganisationId=" +
          (userData.organisationId || "") +
          "&isInternalAdmin=" +
          (userData.isInternalAdmin || "") +
          "&isInternalUser=" +
          (userData.isInternalUser || "") +
          "&isAdmin=" +
          (userData.isAdmin || "") +
          "&P=" +
          (userData.productArr || ""),
      }
    : {};
};
